class Events {
  static _instance = null;

  constructor() {
    this.validation = null;
    this.validated = null;
    this.submitted = null;
    this.change = null;
    this.error = null;
    this.success = null;
    this.toggleOn = null;
    this.toggleOff = null;
  }

  static instance() {
    if (Events._instance === null) {
      Events._instance = new Events();
    }
    return Events._instance
  }

  get validationEvent() {
    if (this.validation === null) {
      this.validation = document.createEvent("CustomEvent");
      this.validation.initCustomEvent('validation', true, true, null);
    }
    return this.validation;
  }

  get validatedEvent() {
    if (this.validated === null) {
      this.validated = document.createEvent("CustomEvent");
      this.validated.initCustomEvent('validated', true, true, null);
    }
    return this.validated;
  }

  get submittedEvent() {
    if (this.submitted === null) {
      this.submitted = document.createEvent("CustomEvent");
      this.submitted.initCustomEvent('submitted', true, true, null);
    }
    return this.submitted;
  }

  get changeEvent() {
    if (this.change === null) {
      this.change = document.createEvent("CustomEvent");
      this.change.initCustomEvent('change', true, true, null);
    }
    return this.change;
  }

  get successEvent() {
    if (this.success === null) {
      this.success = document.createEvent("CustomEvent");
      this.success.initCustomEvent('success', true, true, null);
    }
    return this.success;
  }

  get errorEvent() {
    this.error = document.createEvent("CustomEvent");
    this.error.initCustomEvent('error', true, true, null);
    return this.error;
  }

  get successEvent() {
    if (this.success === null) {
      this.success = document.createEvent("CustomEvent");
      this.success.initCustomEvent('success', true, true, null);
    }
    return this.success;
  }

  get toggleOnEvent() {
    if (this.toggleOn === null) {
      this.toggleOn = document.createEvent("CustomEvent");
      this.toggleOn.initCustomEvent('toggle_on', false, true, null);
    }
    return this.toggleOn;
  }

  get toggleOffEvent() {
    if (this.toggleOff === null) {
      this.toggleOff = document.createEvent("CustomEvent");
      this.toggleOff.initCustomEvent('toggle_off', false, true, null);
    }
    return this.toggleOff;
  }

}

export default Events.instance()
